import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 20c-3.309 0-6-2.691-6-6s2.691-6 6-6c.467 0 .931.06 1.405.181L15.293.293A.996.996 0 0 1 16 0h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2v3a1 1 0 0 1-1 1h-3.586l-.595.595c.121.474.181.938.181 1.405 0 3.309-2.691 6-6 6m1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4c0-.434-.083-.875-.254-1.349a1 1 0 0 1 .234-1.046l1.313-1.312A.996.996 0 0 1 12 10h3V7a1 1 0 0 1 1-1h2V2h-1.586l-8.019 8.02a1.005 1.005 0 0 1-1.046.234A3.934 3.934 0 0 0 6 10"
});

var SvgKeyMajorMonotone = function SvgKeyMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgKeyMajorMonotone as S };